<div class="flex flex-col w-full">
  <div class="w-full overflow-x-auto">
    <div class="py-2 align-middle inline-block w-full box-border">
      <div class="">
        <table class="min-w-full divide-y divide-neutral-400 table-fixed">
          <thead class="bg-primary-700">
            @for (headerGroup of table.getHeaderGroups(); track headerGroup) {
              <tr class="text-white">
                @for (header of headerGroup.headers; track header) {
                  <th
                    [attr.colspan]="header.colSpan"
                    scope="col"
                    class="px-3 py-2 text-left text-sm font-medium border-r last:border-r-0 border-neutral-400 first:rounded-tl-lg last:rounded-tr-lg"
                    [ngClass]="getColumnClass(header.column.id)">
                    @if (!header.isPlaceholder) {
                      <div
                        [class.cursor-pointer]="header.column.getCanSort()"
                        (click)="
                          header.column.getToggleSortingHandler()?.($event)
                        "
                        (keydown.enter)="
                          header.column.getToggleSortingHandler()?.($event)
                        "
                        tabindex="0"
                        role="button"
                        [attr.aria-label]="'Sort by ' + header.id"
                        class="flex items-center justify-between">
                        {{ header.column.columnDef.header }}
                        @if (header.column.getCanSort()) {
                          @switch (header.column.getIsSorted()) {
                            @case ('asc') {
                              <span class="pl-2">
                                <icon name="arrowUp" />
                              </span>
                            }
                            @case ('desc') {
                              <span class="pl-2">
                                <icon name="arrowDown" />
                              </span>
                            }
                            @default {
                              <span class="pl-2">
                                <icon name="doubleArrow" />
                              </span>
                            }
                          }
                        }
                      </div>
                    }
                  </th>
                }
              </tr>
            }
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            @if (loading()) {
              @for (i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]; track i) {
                <tr>
                  @for (header of getVisibleLeafHeaders(); track header.id) {
                    <td
                      class="px-3 py-2 text-sm text-neutral-950 border border-neutral-400"
                      [ngClass]="getColumnClass(header.column.id)">
                      <div
                        class="relative h-4 w-full rounded bg-gray-100 overflow-hidden">
                        <app-skeleton />
                      </div>
                    </td>
                  }
                </tr>
              }
            } @else {
              @for (row of table.getRowModel().rows; track row.id) {
                <tr>
                  @for (cell of row.getVisibleCells(); track cell.id) {
                    <td
                      class="px-3 py-2 text-sm text-neutral-950 border border-neutral-400"
                      [ngClass]="getColumnClass(cell.column.id)">
                      <ng-container
                        *flexRender="
                          cell.column.columnDef.cell;
                          props: cell.getContext()
                        ">
                        <div [innerHTML]="cell.renderValue()"></div>
                      </ng-container>
                    </td>
                  }
                </tr>
              } @empty {
                <tr>
                  <td colspan="100%" class="text-center pt-8 text-text text-sm">
                    No data retrieved for the selected filters
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
